import entitledAppsList from './entitledAppsList'
import selectedAccount from './selectedAccount'
import isAuthenticated from './isAuthenticated'
import wrapperClassName from './wrapperClassName'
import instanceName from './instanceName'
import { globalLoadingMask, globalLoadingMessage } from './globalLoading'
import roles from './roles'
import appPortalUrl from './appPortalUrl'
import pendoIdentified from './pendoIdentified'
import appBarProps from './setAppBarProps'
import { GLOBAL_CONTEXT, FT } from '../utils/contextFT'

// reuse the same logic for app-switcher
const entitlementFetching = globalLoadingMask

const NOT_LOADED_SUPPORT_ACCOUNTS = Object.freeze(Object.defineProperties([], {
  init: { value: true }
}))
const supportAccountIds = (state = NOT_LOADED_SUPPORT_ACCOUNTS, action) => {
  // the parsed json array version
  if (action.type === 'FETCH_CREDENTIALS_SUCCESS' && action.data && action.data.credentials) {
    const { supportAccountIds, supportAccounts = supportAccountIds, defaultsupportaccount } = action.data.credentials
    if (Array.isArray(supportAccounts)) {
      supportAccounts.defaultSupportAccount = defaultsupportaccount > 0 ? +defaultsupportaccount : undefined
      supportAccounts.forEach((acct, idx) => {
        acct.accountid = +acct.accountid
        acct.support_account_id = acct.support_account_id || String(acct.accountid)
        acct.support_account_name = acct.name
        acct.support_account_index = acct.index >= 0 ? acct.index : idx
        if (acct.accountid === supportAccounts.defaultSupportAccount) {
          acct.default_account = true
        }
        acct.roles = acct.roles || []
        acct.rbacRoles = acct.rbacRoles || {}
      })
      return Object.assign(supportAccounts, { loaded: true })
    }
    return Object.assign([], { loaded: true })
  }
  return state
}

const portalSettings = (state = {}) => state

const user = (state = GLOBAL_CONTEXT.username || '', action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS': {
      const credentials = action.data.credentials
      return credentials ? `${credentials.firstname || ''} ${credentials.lastname || ''}`.trim() || credentials.email : ''
    }
    default:
      return state
  }
}

const user_email = (state = '', action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS': {
      const credentials = action.data.credentials
      return (credentials && credentials.email) || ''
    }
    default:
      return state
  }
}

const notonorafter = (state = '0', action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS': {
      const credentials = action.data.credentials
      return (credentials && credentials.notonorafter) || '0'
    }
    default:
      return state
  }
}

/**
 * APPORTAL-905 RBAC, We need JWT token for RBAC in order to communicate with ISS
 * @param state
 * @param action
 * @returns {*}
 */
const jwtToken = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS': {
      const { credentials: { accesstoken = '', pingcert = '' } = {} } = action.data
      return { accesstoken, pingcert }
    }
    default:
      return state
  }
}

const isAppBarSideCollapsed = (state = false, action) => {
  switch (action.type) {
    case 'APP_BAR_COLLAPSED': {
      return action.isCollapsed
    }
    default:
      return state
  }
}

const globalContext = (state = GLOBAL_CONTEXT) => state

const reducers = {
  appPortalUrl,
  entitledAppsList,
  selectedAccount,
  isAuthenticated,
  wrapperClassName,
  user,
  user_email,
  instanceName,
  notonorafter,
  supportAccountIds,
  entitlementFetching,
  globalLoadingMask,
  globalLoadingMessage,
  roles,
  globalContext,
  portalSettings,
  jwtToken,
  appBarProps: appBarProps,
  ...(FT('UI_PENDO') && { pendoIdentified }),
  isAppBarSideCollapsed,
}

export default reducers
